module.exports = __webpack_public_path__ + "static/media/game-display-2@2x.930a21ac.png";